import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: ${props => props.margin};
  border-radius: 10px;
  color: ${props => props.removalPossible ? '#fff' : '#333'};
  padding: 0 5px 0 0;
  position: relative;
`;

@observer
class FeedbackItem extends React.Component {

  static defaultProps = {
    margin: '0 5px 0 0',
  };

  render() {
    return (
      <Wrapper
        onClick={this.props.onClick}
        margin={this.props.margin}
      >
        {this.props.children}
      </Wrapper>
    );
  }
}

export default ErrorBoundary(FeedbackItem);
